import { render } from "./Events.view.vue?vue&type=template&id=e63a2d9c"
import script from "./Events.view.vue?vue&type=script&lang=js"
export * from "./Events.view.vue?vue&type=script&lang=js"

import "./Events.view.vue?vue&type=style&index=0&id=e63a2d9c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__